<!-- components/ReportPopup.vue -->
<template>
    <div class="tl_popup tl_report_popup">
      <main class="tl_popup_body">
        <form>
          <section>
            <h2 class="tl_popup_header">举报内容</h2>
            <div class="tl_radio_items">
              <label v-for="(label, value) in reportReasons" :key="value" class="tl_radio_item">
                <input type="radio" class="radio" :value="value" v-model="selectedReason">
                <span class="tl_radio_item_label">{{ label }}</span>
              </label>
            </div>
            <div class="tl_textfield_item">
              <input type="text" class="tl_textfield" v-model="reportComment" placeholder="添加备注...">
            </div>
          </section>
          <aside class="tl_popup_buttons">
            <button type="button" class="button" @click="$emit('close')">取消</button>
            <button type="button" class="button submit_button" @click="submitReport">提交</button>
          </aside>
        </form>
      </main>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ReportPopup',
    data() {
      return {
        selectedReason: '',
        reportComment: '',
        reportReasons: {
          violence: '暴力内容',
          childabuse: '儿童虐待',
          copyright: '版权问题',
          illegal_drugs: '违禁药品',
          personal_details: '个人信息泄露',
          other: '其他'
        }
      }
    },
    methods: {
      submitReport() {
        // 这里可以添加实际提交逻辑
        console.log('举报内容：', {
          reason: this.selectedReason,
          comment: this.reportComment
        })
        this.$emit('close')
      }
    }
  }
  </script>
  
  <style scoped>
  .tl_report_popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    z-index: 1000;
  }
  .tl_radio_item {
    display: block;
    margin: 8px 0;
  }
  .tl_textfield {
    width: 100%;
    padding: 8px;
    margin: 10px 0;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  </style>